import { createFileRoute } from "@tanstack/react-router";
import SettingDetail from "@/pages/settings/SettingDetail";

export const Route = createFileRoute("/settings/$settingKey")({
  component: SettingDetail,
});
